//Componentes generales
import React, { useReducer, useEffect, useContext } from "react";
import sistemaReducer from "./sistemaReducer";
import sistemaContext from "./sistemaContext";
import authContext from "../authentication/authContex";


//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getAllSistema, addSistema, updateSistema, deleteSistema } from "../../api/sistema"

//Acciones
import { ACTUALIZAR_LIST_SISTEMA} from "./sistemaAction";

/* 
    State encargado de la gestión de productos.
*/
const SistemaState = props => {

    //Valores iniciales
    const initialState = {
        sistema: [],
    };

    const [state, dispatch] = useReducer(sistemaReducer, initialState);
    const auContext = useContext(authContext);
    const {usuario} = auContext;
    
    const actualizarSistema = async () => {

        try{

            const resp = await getAllSistema();

            dispatch({
                type: ACTUALIZAR_LIST_SISTEMA,
                payload: resp.data.data
            })

            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    const agregarSistema = async (dato) => {

        try{
            const resp = await addSistema(dato);
            const sistema = resp.data.data;
            
            return sistema;
        }catch(err){
            console.log(err);
            return null;
            
        }
        
    };

    const modificarSistema = async (dato) => {
        try{
            
            const resp = await updateSistema(dato);
            const sistema = resp.data.data;
            
            return sistema;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarSistema = async (id) => {
        try{
            
            const resp = await deleteSistema(id);
            const sistema = resp.data.data;
            
            return sistema;
        }catch(err){
            console.log(err)
        }
    }

useEffect(() => {
    if(usuario != null) actualizarSistema();
},[usuario])


    return(
        <sistemaContext.Provider
            value={{
                sistema: state.sistemaList,
                actualizarSistema,
                agregarSistema,
                modificarSistema,
                eliminarSistema
            }}
        >

            {props.children}

        </sistemaContext.Provider>
    )
    
}

export default SistemaState;